import * as React from "react";
import { graphql } from "gatsby";

import Layout from "../components/layout";
import Seo from "../components/seo";

// import Hero from "components/hero";
import Footer from "../components/footer";
import PageHeader from "../components/pageheader";
import { BlogTitle, Highlight, SubTitle } from "../components/atoms";
// import MapSummary from "../components/charts/map";
// import DataView from "../components/dataview/data";
import "antd/dist/antd.css";
import ElectionTimeline from "../components/dataview/timeline";
import Geo from "../components/dataview/geo";
import SocMedia from "../components/dataview/soc";

const Landing = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title;
  // console.log(">>>>> ", location);
  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="2019 Election Analysis" />
      <PageHeader activePage={"/"}>
        <div className=" z-8    rounded">
          <BlogTitle>
            {" "}
            Understanding Citizen Participation in the 2019 Nigerian Elections{" "}
            <div className="mb-4 mt-1 text-sm font-normal">
              Applying data analytics, machine learning and visualization
              techniques in understanding key events associated with the 2019
              Nigerian elections, citizen engagement, candidate use of social
              media, and geo political stuctures.
            </div>
          </BlogTitle>
          <div className="rounded hidden  p-2 text-sm mt-2 mb-2 bg-green-100">
            {" "}
            <span className="font-semibold">Note:</span> This project is still
            in development. Expected completion : ~06/31/2022.
          </div>{" "}
          <div className=" text-gray-500  text-base">
            {" "}
            This project began on the premise that the proliferation of social
            media interactions provides an interesting lens to study human
            behavior, and ask important questions about election discourse in
            Nigeria as well as interrogate social/demographic questions. It is
            based on data collected from twitter between September 2018 to March
            2019 (tweets geotagged to Nigeria and tweets containing election
            related keywords). Overall, the data set contains{" "}
            <Highlight>25.2 million</Highlight> tweets and retweets,{" "}
            <Highlight>12.6 million</Highlight> original tweets{" "}
            <Highlight>8.6 million</Highlight> geotagged tweets and{" "}
            <Highlight>3.6 million</Highlight> tweets labelled (using an ML
            model) as political.
            {/* For example, how do
            candidates leverage social media? Are social media interactions
            reflective of candidate popularity or decoupled from on-the-ground
            results? Are there regional differences in online political
            discourse participation? The period leading up to a general election
            presents us with the ability to collect data and study these
            questions in a high-engagement setting that is perhaps more
            representative actual demographics. As part of this process, I wrote
            a data collection script that used the twitter api to collect data
            corresponding to mentions of election related keywords and tweets
            geolocated to Nigeria. The script ran from September 2018 to March
            2019. Overall, this data set contains 25.2 million tweets and
            retweets, 12.6 million original tweets and 8.6 million geotagged
            tweets. This project applies machine learning and data analysis
            techniques to this dataset with the goal of understanding citizen
            participation in the 2019 Nigerian presidential elections. */}
            <div className="mt-4">
              {/* <div className="text-2xl font-semibold">Dataset</div>
              <div>
                The dataset used in this project was assembled over the the
                period of 5 months spanning ... to ...
              </div> */}
            </div>
            <SubTitle> Presidential Election Timeline </SubTitle>
            <div className="pp-2   border-b-2 pb-6 ">
              <ElectionTimeline />
            </div>
            <SubTitle> Candidate Use of Social Media </SubTitle>
            <div className="pp-2  border-b-2 pb-6 ">
              <SocMedia />
            </div>
            <SubTitle> Geo Tagged Data </SubTitle>
            <div className="pp-2 rounded ">
              <Geo />
            </div>
            {/* <SubTitle> Dataset Overview </SubTitle>
            <div className="pp-2 rounded ">
              <DataView />
            </div> */}
            {/* <SubTitle> Geographic Distribution of Tweets </SubTitle>
            <div className="rounded ">
              <MapSummary />
            </div> */}
            <div className="mt-16 mb-2">
              <div className="font-semibold mt-10 mb-2">Acknowledgement</div>
              <div className="text-sm">
                This work began in 2018 and would not be possible without the
                generous support GCP credits from the Google Developer Expert
                program (ML Ecosystem team). These credits were used to run VMs
                for ingesting tweets, storage / processing in BigQuery and
                compute VMs for training ML models.
              </div>
              <div className="mt-2 text-xs">
                Note: this work constitutes academic research and not intended
                to be the sole source of information for decision making.
              </div>
            </div>
          </div>
        </div>
      </PageHeader>

      <Footer />
    </Layout>
  );
};

export default Landing;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
